package models

import kotlinx.serialization.Serializable


@Serializable
data class VideoDetails(

    val id: Int?,
    val kinopoiskId: String? = null,
    val imdbId: String? = null,
    val title: String? = null,
    val description: String? = null,
    val quality: String? = null,
    val imageUrl: String? = null,
    val backdropUrl: String? = null,
    val kinopoiskRating: String? = null,
    val imbdRating: String? = null,
    val kinoshkaRating: String? = null,
    val genres: List<Genre>? = null,
    val countries: List<Country>? = null,
    val adult: Boolean? = null,
    val year: String? = null,
    val trailerUrl: String? = null,
    val videoUrl: String? = null,
    val seasons: List<Season>? = null,
    var isTvShow: Boolean = seasons != null,
) {

    @Serializable
    data class Season(
        val id: Int,
        val seasonNumber: Int,
        val title: String?,
        val description: String?,
        val imageUrl: String?,
        val trailerUrl: String? = null,
        val episodes: List<Episode>?,
    )

    @Serializable
    data class Episode(
        val id: Int,
        val episodeNumber: Int,
        val videoUrl: String? = null,
        val imageUrl: String?,
    )
}